<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-7"></a>
<h2 class="chap2_2">Author’s biography</h2>
<div class="img_container1">
<img alt="Image" class="inline" src="images/img1.jpg"/>
</div>
<p class="noindent ts14">Stephen is a happily retired police officer having served with Essex Police as a constable for thirty years between 1983 and 2013. He is married to Tanya who is also his best friend.</p>
<p class="indent"><span class="ts14">Both his sons, Luke and Ross, were members of the armed forces, collectively serving five tours of Afghanistan between 2008 and 2013. Both were injured on their first tour. This led to his first book </span><span class="ts15">Two Sons in a Warzone – Afghanistan: The True Story of a Fathers Conflict</span><span class="ts14">, published in October 2010.</span></p>
<p class="indent ts14">He has a teenage daughter, Aimee, who currently attends secondary school.</p>
<p class="indent ts14">Both of his grandfathers served in and survived the First World War, one with the Royal Irish Rifles, the other in the Mercantile Navy. His father was a member of the Royal Army Ordnance Corps during the Second World War.</p>
<p class="indent"><span class="ts14">Stephen collaborated with one of his writing partners, Ken Porter, on a previous book published in August 2012, </span><span class="ts15">‘German POW Camp 266 – Langdon Hills</span><span class="ts14">, which spent six weeks as the number one bestselling book in Waterstones, Basildon between March and April 2013. Steve and Ken collaborated on a further four books in the ‘Towns &amp; Cities in the Great War’ series by Pen &amp; Sword. Stephen has also written other titles for the same series of books.</span></p>
<p class="indent ts14">Stephen has also cowritten three crime thrillers which were published between 2010 and 2012; they centre around a fictional detective named Terry Danvers.</p>
<p class="indent ts14">When he is not writing, Tanya and he enjoy the simplicity of walking their four German Shepherd dogs early each morning when most sensible people are still fast asleep in their beds.</p>
<a id="VPS-8"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Author.vue?2c13d8e5